// extracted by mini-css-extract-plugin
module.exports = {"list":"Breadcrumbs-module__list___Q6IdN","item":"Breadcrumbs-module__item___bISqi","icon":"Breadcrumbs-module__icon___k11Zw"};